import { runGqlMutation, runGqlQuery } from "@/graphql/gqlUtil.js";
import {
  CREATESHORTAGE,
  CREATETEMPLATE,
  DELETESHORTAGE,
  DELETETEMPLATE,
} from "@/graphql/InvoiceMutations.js";
import {
  GETDEPARTMENT,
  GETINVENTORY,
  GETSHORTAGE,
  GETTEMPLATE,
} from "@/graphql/InvoiceQueries.js";
import common from "@/util/common.js";
import Demical from "decimal.js";

const state = () => ({
  invoiceList: [],
  pages: 0,
  invoiceOne: {
    invoiceNumber: 0,
    date: "",
    companyName: "",
    address: "", // 주소 => address1 + address2 + city + zipcode
    phone: "",
    GrandTotal: 0,
    custNum: "",
    itemList: [],
  },
  originInvoice: {
    // update 모달창 원본 데이터
    invoiceNumber: 0,
    date: "",
    companyName: "",
    address: "", // 주소 => address1 + address2 + city + zipcode
    phone: "",
    GrandTotal: 0,
    custNum: "",
    itemList: [],
  },
  departments: [],
  prices: [],
  inventoryList: [],
  inventoryPages: 0,
  latestPricesList: [],
  templateList: [],
  templatePages: 0,
  shortageList: [],
  shortageListAll: [],
  shortagePages: 0,
});

const actions = {
  async addTemplate({ commit }, payload) {
    try {
      const updateResult = await runGqlMutation(CREATETEMPLATE, {
        custNum: payload.custNum,
        itemNum: payload.itemNum,
      });

      if (updateResult.message === undefined) {
        return commit(
          "common/snackOn",
          { text: "Add Template Complete!" },
          { root: true }
        );
      } else {
        return commit(
          "common/snackErrOn",
          { text: "Add Template Failed!" },
          { root: true }
        );
      }
    } catch (err) {
      console.error("addTemplate: " + err);
    }
  },
  async getCategory({ commit }) {
    try {
      const categoryResult = await runGqlQuery(GETDEPARTMENT);

      if (categoryResult.message === undefined) {
        await commit("setDepartments", categoryResult.getDepartments);
      }
    } catch (err) {
      console.error("getCategory: " + err);
    }
  },
  async getTemplates({ commit }, payload) {
    try {
      const templateResult = await runGqlQuery(GETTEMPLATE, {
        CustNum: payload.CustNum,
      });

      if (templateResult.message === undefined) {
        return await commit("setTemplateList", {
          getTemplates: templateResult.getTemplates,
        });
      } else {
        return commit(
          "common/snackErrOn",
          { text: "There is no Template List!" },
          { root: true }
        );
      }
    } catch (err) {
      console.error("getTemplates: " + err);
    }
  },
  async getTemplatesForAdd({ commit }, payload) {
    try {
      const templateResult = await runGqlQuery(GETTEMPLATE, {
        CustNum: payload.CustNum,
      });

      if (templateResult.message === undefined) {
        return templateResult.getTemplates;
      } else {
        return commit(
          "common/snackErrOn",
          { text: "There is no Template List!" },
          { root: true }
        );
      }
    } catch (err) {
      console.error("getTemplates: " + err);
    }
  },
  async deleteTemplate({ commit }, payload) {
    try {
      const updateResult = await runGqlMutation(DELETETEMPLATE, {
        _id: payload._id,
      });

      if (updateResult.message === undefined) {
        return commit(
          "common/snackOn",
          { text: "Delete Template Complete!" },
          { root: true }
        );
      } else {
        return commit(
          "common/snackErrOn",
          { text: "Delete Template Failed!" },
          { root: true }
        );
      }
    } catch (err) {
      console.error("deleteTemplate: " + err);
    }
  },
  async getInventoryList({ commit }, payload) {
    try {
      const inventoryResult = await runGqlQuery(GETINVENTORY, {
        Column: payload.Column,
        Search: payload.Search,
        Dept_ID: payload.Dept_ID,
        Page_No: payload.Page_No,
        Page_Size: payload.Page_Size,
      });

      if (inventoryResult.message === undefined) {
        await commit("setInventoryList", {
          getInventories: inventoryResult.getInventories,
          belong: payload.belong,
        });
        if (inventoryResult.getInventories.length === 0) {
          return "no data";
        }
      } else {
        return "no data";
      }
    } catch (err) {
      console.error("getInventoryList: " + err);
    }
  },
  async createShortageList({ commit }, payload) {
    try {
      const updateResult = await runGqlMutation(CREATESHORTAGE, {
        ItemNum: payload.ItemNum,
      });

      if (updateResult.message === undefined) {
        return commit(
          "common/snackOn",
          { text: "Shortage creation succeeded!" },
          { root: true }
        );
      } else {
        return commit(
          "common/snackErrOn",
          { text: "Failed to create Shortage!" },
          { root: true }
        );
      }
    } catch (err) {
      console.error("createShortageList: " + err);
    }
  },
  async getShortageList({ commit }, payload) {
    try {
      const req = { Page_No: payload.Page_No, Page_Size: payload.Page_Size };

      const shortageResult = await runGqlMutation(GETSHORTAGE, req);

      if (
        shortageResult.message === undefined &&
        shortageResult.getShortages.length !== 0
      ) {
        return await commit("setShortageList", shortageResult.getShortages);
      } else {
        return "noData";
      }
    } catch (err) {
      console.error("getShortageList: " + err);
    }
  },
  async getShortageListAll({ commit }) {
    try {
      const shortageResult = await runGqlMutation(GETSHORTAGE, {});

      if (shortageResult.message === undefined) {
        return await commit("setShortageListAll", shortageResult.getShortages);
      }
    } catch (err) {
      console.error("getShortageListAll: " + err);
    }
  },
  async deleteShortage({ commit }, payload) {
    try {
      const updateResult = await runGqlMutation(DELETESHORTAGE, {
        ItemNum: payload.ItemNum,
      });
      if (updateResult.message == undefined) {
        return commit(
          "common/snackOn",
          { text: "The Shortage was successfully deleted!" },
          { root: true }
        );
      } else {
        return commit(
          "common/snackErrOn",
          { text: "Failed to delete Shortage!" },
          { root: true }
        );
      }
    } catch (err) {
      console.error("deleteShortage: " + err);
    }
  },
};

// mutations
const mutations = {
  setInvoiceList(state, payload) {
    try {
      const temp = payload.invoices;
      const newArray = [];

      temp.map((data) => {
        if (data.Invoice_Number.length > 0) {
          if (data.CustNum != null && data.Invoice_Number[0].length != 0) {
            const listOne = {};

            listOne.custNumber = data.CustNum;
            listOne.orderTime = data.DateTime.substr(0, 19);
            listOne.invoiceNumber = data.Invoice_Number[0].Invoice_Number;
            listOne.status = data.Status;
            listOne.company = data.Company;

            newArray.push(listOne);
          }
        }
      });

      state.invoiceList = newArray;
    } catch (e) {
      console.log(e);
    }
  },
  setInvoiceOne(state, payload) {
    try {
      state.invoiceOne.invoiceNumber =
        payload.Invoice_Number[0]?.Invoice_Number;
      state.invoiceOne.date = common.typeDate(payload.DateTime);
      state.invoiceOne.custNum = payload.CustNum;
      state.invoiceOne.companyName =
        (payload.Company || "") + " " + (payload.First_Name || "");
      state.invoiceOne.address =
        (payload.Address_1 || "") +
        " " +
        (payload.Address_2 || "") +
        " " +
        (payload.City || "") +
        " " +
        (payload.Zip_Code || "");

      const phone = payload.Phone_1 || "" || payload.Phone_2 || "" || "";
      if (phone != "") state.invoiceOne.phone = phone;
      state.invoiceOne.status = payload.Status;
      state.invoiceOne.itemList = payload.Invoice_Number;
      let grandTotal = 0;
      state.invoiceOne.itemList.forEach((data) => {
        if (typeof data.Total == "number") {
          grandTotal += data.Total;
        }
      });
      state.invoiceOne.GrandTotal = grandTotal;
    } catch (e) {
      console.log(e);
    }
  },
  setInvoiceOneOrigin(state, payload) {
    try {
      state.originInvoice.invoiceNumber =
        payload.Invoice_Number[0]?.Invoice_Number;
      state.originInvoice.date = common.typeDate(payload.DateTime);
      state.originInvoice.custNum = payload.CustNum;
      state.originInvoice.companyName =
        (payload.Company || "") + " " + (payload.First_Name || "");
      state.originInvoice.address =
        (payload.Address_1 || "") +
        " " +
        (payload.Address_2 || "") +
        " " +
        (payload.City || "") +
        " " +
        (payload.Zip_Code || "");

      const phone = payload.Phone_1 || "" || payload.Phone_2 || "" || "";
      if (phone != "") state.originInvoice.phone = phone;
      state.originInvoice.status = payload.Status;
      state.originInvoice.itemList = payload.Invoice_Number;
      let grandTotal = 0;
      state.originInvoice.itemList.forEach((data) => {
        if (typeof data.Total == "number") {
          grandTotal += data.Total;
        }
      });
      state.originInvoice.GrandTotal = grandTotal;
    } catch (e) {
      console.log(e);
    }
  },
  setPrices(state, payload) {
    try {
      const temp = payload;
      const newArray = [];

      temp.map((data) => {
        newArray.push(data);
      });

      state.prices = newArray;
    } catch (e) {
      console.log(e);
    }
  },
  setDepartments(state, payload) {
    try {
      const temp = payload;
      const newArray = [
        {
          name: "All",
          value: "",
        },
      ];
      temp.map((data) => {
        const tempOne = {};
        tempOne.name = data.Description;
        tempOne.value = data.Dept_ID;
        newArray.push(tempOne);
      });

      state.departments = newArray;
    } catch (e) {
      console.log(e);
    }
  },
  setInventoryList(state, payload) {
    try {
      const temp = payload.getInventories;
      const newArray = [];

      temp.map((data) => {
        const inventoryOne = {};

        inventoryOne.itemNum = data.ItemNum;
        inventoryOne.itemName = data.ItemName;
        inventoryOne.vendorName = data.Company;

        state.departments.map((departData) => {
          if (departData.value == data.Dept_ID) {
            inventoryOne.department = departData.name;
          }
        });

        if (payload.belong == "Shortage") {
          inventoryOne.inShortage = false;
          if (state.shortageListAll.length != 0) {
            state.shortageListAll.map((shortData) => {
              if (
                shortData.ItemNum == data.ItemNum &&
                shortData.State == "Checking"
              ) {
                inventoryOne.inShortage = true;
              }
            });
          }
        } else if (payload.belong == "Template") {
          inventoryOne.inTemplate = false;
          state.templateList.map((tempData) => {
            if (tempData.itemNum == data.ItemNum) {
              inventoryOne.inTemplate = true;
            }
          });
        }

        newArray.push(inventoryOne);
      });

      state.inventoryList = newArray;
    } catch (e) {
      console.log(e);
    }
  },
  setLatestPrices(state, payload) {
    try {
      const temp = payload;
      let newArray = [];

      temp.map((data) => {
        newArray.push(data);
      });

      const round = (num) => {
        var m = Number((Math.abs(num) * 100).toPrecision(15));
        return (Math.round(m) / 100) * Math.sign(num);
      };

      const getProfitPer2 = (price, cost) => {
        return round(
          ((Demical((price * 1 - cost * 1) / cost) * 1 * 100) / 1).toFixed(3)
        );
        //this.getProfitPer(
        //);
      };

      newArray = newArray.map((item) => {
        return {
          ...item,
          // Quantity: item.Quantity,
          Profit: +(
            Math.round(
              item.PricePer * 1 * item.Quantity -
                item.CostPer * 1 * item.Quantity +
                "e+2"
            ) + "e-2"
          ),
          ProfitPer:
            item.Quantity != 0
              ? getProfitPer2(item.PricePer, item.CostPer)
              : 0 + "e+2" + "e-2" * 100,
        };
      });

      state.latestPricesList = newArray;
    } catch (e) {
      console.log(e);
    }
  },
  setTemplateList(state, payload) {
    try {
      const temp = payload.getTemplates;
      const newArray = [];

      temp.map((data) => {
        const templateOne = {};

        templateOne._id = data._id;
        templateOne.itemNum = data.ItemNum;
        templateOne.ItemName = data.ItemName !== null ? data.ItemName : "";
        templateOne.ItemNum = data.ItemNum;
        templateOne.CustNum = data.CustNum;
        templateOne.Quantity = data.Quantity;
        templateOne.ItemName_Extra =
          data.ItemName_Extra !== null ? data.ItemName_Extra : "";
        templateOne.Vendor_Part_Num = data.Vendor_Part_Num;
        templateOne.CostPer = data.Cost;
        templateOne.ChargedPrice = data.ChargedPrice;
        templateOne.In_Stock = data.In_Stock;
        templateOne.PricePer = data.Price;
        if (data.ItemName)
          templateOne.isCRV = data.ItemName.includes("CRV") ? false : true;
        else templateOne.isCRV = true;

        templateOne.itemName =
          templateOne.ItemName + " " + (templateOne.ItemName_Extra || "");
        templateOne.company = data.Company || "";
        state.departments.map((deptData) => {
          if (data.Dept_ID == deptData.value) {
            templateOne.dept = deptData.name;
          }
        });
        newArray.push(templateOne);
      });

      state.templateList = newArray;
    } catch (e) {
      console.log(e);
    }
  },
  setShortageList(state, payload) {
    try {
      // itemNum itemName vendor department require orde avail
      const temp = payload;
      const newArray = [];

      temp.map((data) => {
        const shortageOne = {};

        shortageOne.ItemNum = data.ItemNum;
        shortageOne.ItemName = data.ItemName;
        shortageOne.Company = data.Company;
        state.departments.map((deptData) => {
          if (data.Dept_ID == deptData.value) {
            shortageOne.dept = deptData.name;
          }
        });
        shortageOne.Required = data.Required;
        shortageOne.Ordered = data.Ordered;
        shortageOne.Available = data.Available;
        shortageOne.State = data.State;

        newArray.push(shortageOne);
      });

      state.shortageList = newArray;
      return true;
    } catch (e) {
      console.log(e);
    }
  },
  setShortageListAll(state, payload) {
    try {
      const temp = payload;
      const newArray = [];

      temp.map((data) => {
        const shortageOne = { ItemNum: data.ItemNum, State: data.State };
        newArray.push(shortageOne);
      });

      state.shortageListAll = newArray;
    } catch (e) {
      console.log(e);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
